import type { NavigationBridgeAdapter } from '@rover/rsdk/src/bridges/adapters/types';

const noop = (): void => {};

// Web-safe stub so shared components can use useNavigation() without throwing due to the missing BridgeAdaptersProvider (native only).
const noopNavigation: NavigationBridgeAdapter = {
  appTrackingTransparencyOnboardingCtaPressed: noop,
  archiveConversation: noop,
  bookingDetails: noop,
  checkPermissions: () => Promise.resolve(false),
  deeplinkUrl: '',
  dismiss: noop,
  finishOnboarding: noop,
  leadTimeSelected: noop,
  onPageResult: noop,
  openAcceptModificationsAndPayPage: noop,
  openAssembledChat: noop,
  openAuthThenBecomeSitter: noop,
  openAuthThenLemonadePetInsurance: noop,
  openContactPage: noop,
  openContactPageAfterAuth: noop,
  openContactPageAfterAuthAND: noop,
  openContactPageIOS: noop,
  openConversationPostCreationAndroid: noop,
  openConversationPostCreationiOS: noop,
  openConversationReportFlowAndroid: noop,
  openConversationReportFlowIOS: noop,
  openConversationUrl: noop,
  openCreditCardContainer: noop,
  openDeepLink: noop,
  openHomeView: noop,
  openLogIn: noop,
  openMap: noop,
  openMessagingWithRoverSupport: noop,
  openOwnerPetsScreen: noop,
  openReportFlowAndroid: noop,
  openReportFlowIOS: noop,
  openRequestEditor: noop,
  openSignUp: noop,
  openSitterProfile: noop,
  pop: noop,
  openDeepLinkReplacingCurrent: noop,
  popOrDismiss: noop,
  popToRoot: noop,
  popWithAnimation: () => Promise.resolve(),
  push: noop,
  pushNative: noop,
  pushReplacingCurrent: noop,
  refreshExperiments: noop,
  selectDatesFromCalendar: () => Promise.resolve([]),
  selectLocation: () => Promise.resolve(''),
  selectSingleDateFromDatePicker: () => Promise.resolve(null),
  showCalendarSurvey: noop,
  signStaticMap: () => Promise.resolve(''),
  startVideoCall: noop,
  trackScreenLoadMetric: noop,
  updateUnreadStatus: noop,
};

export function useNavigation(): NavigationBridgeAdapter {
  return noopNavigation;
}

export default noopNavigation;
